import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import DialogCloseButton from "../buttons/DialogCloseButton";
import MessageBox, {MessageType} from "../components/MessageBox";
import {UserRole} from "../../models/account";
import {Tour} from "../../models/tour";
import {MembershipsInTour, TourMembership} from "../../models/membership";
import TourMemberForm from "../forms/tour/TourMemberForm";
import {isNowInRange} from "../../utils/formatDateTime";

type Props = {
    tour?: Tour | null;
    membership?: TourMembership | null;
    membershipsInTour?: MembershipsInTour;
    showOtherMembers: boolean;
    onReloadMembershipsInTour?: () => void;
    onClose: () => void;
    onSaved: () => void;

    // NEU: Render-Prop
    renderForm: (args: {
        setMessage: (msg: MessageType) => void;
        onSaved: () => void;
    }) => React.ReactNode;
};

export default function TourDialog({
                                       tour,
                                       membership,
                                       membershipsInTour,
                                       onReloadMembershipsInTour,
                                       onClose,
                                       onSaved,
                                       renderForm
                                   }: Props) {
    const {t} = useTranslation();

    const isActive = tour ? isNowInRange(tour.validFrom, tour.validTo) && membership?.role !== UserRole.APPLIED : false;
    const isPrivileged = membership?.role === UserRole.ADMIN || membership?.role === UserRole.CREATOR;

    const initialTab: "edit" | "members" =
        !tour
            ? "edit"
            : isActive
                ? "members"
                : isPrivileged
                    ? "members"
                    : "edit";

    const [tab, setTab] = useState<"edit" | "members">(initialTab);
    const [message, setMessage] = useState<MessageType>(null);

    const showOtherMembers =
        membership && tour &&
        ((membership.role === UserRole.ADMIN || membership.role === UserRole.CREATOR)
            || (membership.role === UserRole.MEMBER && isNowInRange(tour.validFrom, tour.validTo)));

    return (
        <div className="dialog-overlay">
            <div className="dialog">
                <h3>
                    {tour
                        ? t("tours.dialog.editTour")
                        : t("tours.dialog.createTour")}
                </h3>

                <DialogCloseButton
                    onClose={() => {
                        setMessage(null);
                        onClose();
                    }}
                />

                {tour && showOtherMembers && (
                    <div className="auth-tabs">
                        <button
                            className={`auth-tab ${tab === "edit" ? "active" : ""}`}
                            onClick={() => setTab("edit")}
                        >
                            {t("tours.tabs.edit")}
                        </button>

                        <button
                            className={`auth-tab ${tab === "members" ? "active" : ""}`}
                            onClick={() => {
                                if (isActive || isPrivileged) setTab("members");
                            }}
                            disabled={!(isActive || isPrivileged)}
                        >
                            {t("tours.tabs.members")}
                        </button>
                    </div>
                )}

                <MessageBox message={message}/>

                {/*{tab === "edit" &&*/}
                {/*    renderForm({*/}
                {/*        setMessage,*/}
                {/*        onSaved*/}
                {/*    })*/}
                {/*}*/}

                {tab === "edit" &&
                    renderForm({
                        setMessage,
                        onSaved: () => {
                            setMessage(null);
                            onClose();   // Dialog schließen
                            onSaved();   // Parent informieren
                        }
                    })
                }

                {tab === "members" && tour && membership && membershipsInTour && (
                    <TourMemberForm
                        tour={tour}
                        ownRole={membership.role}
                        membershipsInTour={membershipsInTour}
                        onReloadMembershipsInTour={onReloadMembershipsInTour!}
                        setMessage={setMessage}
                    />
                )}
            </div>
        </div>
    );
}
